<div class="form-group">
  <label [for]="fieldId" class="label text-muted"> {{label}} </label>
  <input type="time" step="1" [formControl]="control" [id]="fieldId" name="" class="form-control form-control-sm">
  <app-form-validation [validationErrors]="validationErrors"></app-form-validation>
</div>
